import { createContext, useContext } from "react";

/** The three modes note 03 §10 records: explicit light, explicit dark, or follow the OS. */
export type ThemeMode = "light" | "dark" | "system";

export interface ThemeState {
  mode: ThemeMode;
  /** What `mode` currently resolves to once the media query is taken into account. */
  resolved: "light" | "dark";
  setMode: (mode: ThemeMode) => void;
  /** light → dark → system → light. Bound to Mod+Shift+L. */
  cycle: () => void;
}

export const ThemeContext = createContext<ThemeState | null>(null);

export function useTheme(): ThemeState {
  const value = useContext(ThemeContext);
  if (value === null) {
    throw new Error("useTheme must be used inside <ThemeProvider>");
  }
  return value;
}

export const themeOrder: ThemeMode[] = ["light", "dark", "system"];
